<div class="container-fluid overflow-hide">
    <div class="row">
        <!--<div class="col-md-12 five">
            <h1>My orders</h1>
        </div>-->
    </div>
    <form [formGroup]="orderProcessing" id="orderProcessing">
        <!--<div class="row mt-3">
            <div class="col-md-4">
                <select class="form-control form-control-sm" id="shopName"
                        (change)="selectShopOrders($event)">
                    <option value="" disabled selected>select Shop Name</option>
                    <option *ngFor="let shop of shopList" value="{{shop.traderId}}">{{shop.traderName}}</option>
                </select>
            </div>
        </div>-->
    </form>
    <div class="card container-fluid p-2 mt-3">
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="btn-group btn-group-justified">
                    <button type="button" class="btn btn-nav"
                            [class.active]="activeTab === 'accepted'"
                            (click)="setActiveTab('accepted'); orderAccepted()">
                        ORDER ACCEPTED <span class="badge bg-secondary">{{ orderAcceptedCount }}</span>
                    </button>

                    <button type="button" class="btn btn-nav"
                            [class.active]="activeTab === 'pickup'"
                            (click)="setActiveTab('pickup'); orderReady()">
                        READY FOR PICKUP <span class="badge bg-secondary">{{ orderPickupCount }}</span>
                    </button>

                    <button type="button" class="btn btn-nav"
                            [class.active]="activeTab === 'delivery'"
                            (click)="setActiveTab('delivery'); orderDelivery()">
                        READY FOR DELIVERY <span class="badge bg-secondary">{{ orderDeliveryCount }}</span>
                    </button>

                    <button type="button" class="btn btn-nav"
                            [class.active]="activeTab === 'closed'"
                            (click)="setActiveTab('closed'); orderClosed()">
                        ORDER CLOSED <span class="badge bg-secondary">{{ orderClosedCount }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card container bg-light mt-3">
            <div class="row mt-2 mb-2">
                <div class="col-lg-8 col-12"></div>
                <div class="input-group col-md-9">
                    <input type="search" class="form-control rounded form-control-sm" [(ngModel)]="searchText"
                           placeholder="Search..." aria-label="Search" aria-describedby="search-addon"/>
                    <span class="input-group-text bg-light border-0" id="search-addon"><i
                            class="fas fa-search"></i></span>
                </div>
            </div>
        </div>

        <div class="container-fluid" [style.display]="orderAcceptedShow ? 'block' : 'none'">
            <div class="row mt-3">
                <div class="col-md-12 table-responsive-md tableFixHead">
                    <table class="table text-center">
                        <thead class="header sticky-top">
                        <tr>
                            <th>S.No</th>
                            <th>Order ID</th>
                            <th>Order Date</th>
                            <th>Customer Name</th>
                            <th>Total Bill Amount</th>
                            <th>Order Type</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                            <th *ngIf="appCode != 'MYKADAI'">Print</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                                *ngFor="let order of retailerAcceptedOrder | filter: searchText; let i = index;"
                                (click)="orderProductModalShow(order.orderId, 'Accepted', order.orderType)"
                                style="cursor: pointer;">
                            <td>{{ i + 1 }}</td>
                            <td>{{ order.orderUID }}</td>
                            <td>{{ order.orderDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="text-capitalize">
                                <p>{{ order.deliveryAddress?.name || order.customerName || '-' }}</p>
                                <small *ngIf="order.deliveryAddress">
                                    {{ getFormattedAddress(order.deliveryAddress) }}
                                </small>
                            </td>
                            <td>
                                {{ (order.totalAmount + order.taxableAmount) | currency: 'INR': 'symbol' }}
                            </td>
                            <td>{{ getOrderStatus(order.orderType) }}</td>
                            <td>
                                <span class="badge save-badge">{{ order.orderStatus }}</span><br>
                            </td>
                            <td><span
                                    [ngClass]="{ 'badge save-badge': order.paymentStatus === 'Paid','badge danger-badge': order.paymentStatus === 'Not Paid'}">{{ order.paymentStatus }}</span>
                            </td>
                            <td *ngIf="appCode !== 'MYKADAI'">
                                <button type="button" class="accept btn btn" (click)="invoicePrint(order.orderId)">
                                    Print
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="container-fluid" [style.display]="orderReadyShow ? 'block' : 'none'">
            <div class="row mt-3">
                <div class="col-md-12 table-responsive-md table-wrapper-scroll-y tableFixHead">
                    <table class="table text-center">
                        <thead class="header sticky-top">
                        <tr>
                            <th>S.No</th>
                            <th>Order ID</th>
                            <th>Order Date</th>
                            <th>Customer Name</th>
                            <th>Total Bill Amount</th>
                            <th>Order Type</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                            <th *ngIf="appCode != 'MYKADAI'">Print</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                                *ngFor="let pickup of retailerPickupOrder | filter: searchText; let i = index;"
                                (click)="orderProductModalShow(pickup.orderId, 'Ready For Pickup', pickup.orderType)"
                                style="cursor: pointer;"
                        >
                            <td>{{ i + 1 }}</td>
                            <td>{{ pickup.orderUID }}</td>
                            <td>{{ pickup.orderDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="text-capitalize">
                                <p *ngIf="pickup.deliveryAddress">
                                    {{ pickup.deliveryAddress?.name }}
                                </p>
                                <p *ngIf="!pickup.deliveryAddress">{{ pickup.customerName || '-' }}</p>
                                <small *ngIf="pickup.deliveryAddress">
                                    {{ getFormattedAddress(pickup.deliveryAddress) }}
                                </small>
                            </td>
                            <td>
                                {{ (pickup.totalAmount + pickup.taxableAmount) | currency: 'INR':'symbol' }}
                            </td>
                            <td>{{ getOrderStatus(pickup.orderType) }}</td>
                            <td>
                                <span class="badge save-badge">{{ pickup.orderStatus }}</span><br>
                                <!-- <small>{{ pickup.orderDate | date: 'dd/MM/yyyy' }}</small>-->
                            </td>
                            <td><span
                                    [ngClass]="{'badge save-badge': pickup.paymentStatus === 'Paid','badge danger-badge': pickup.paymentStatus === 'Not Paid'}">{{ pickup.paymentStatus }}</span>
                            </td>
                            <td *ngIf="appCode !== 'MYKADAI'" (click)="$event.stopPropagation()">
                                <button type="button" class="accept btn btn" (click)="invoicePrint(pickup.orderId)">
                                    Print
                                </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="container-fluid" [style.display]="orderDeliveryShow ? 'block' : 'none'">
            <div class="row mt-3">
                <div class="col-md-12 table-responsive-md table-wrapper-scroll-y tableFixHead">
                    <table class="table text-center">
                        <thead class="header sticky-top">
                        <tr>
                            <th>S.No</th>
                            <th>Order ID</th>
                            <th>Order Date</th>
                            <th>Customer Name</th>
                            <th>Total Bill Amount</th>
                            <th>Order Type</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                            <th *ngIf="appCode != 'MYKADAI'">Print</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                                *ngFor="let delivery of retailerDeliveryOrder | filter: searchText; let i = index;"
                                (click)="orderProductModalShow(delivery.orderId, 'Ready For Delivery', delivery.orderType)"
                                style="cursor: pointer;"
                        >
                            <td>{{ i + 1 }}</td>
                            <td>{{ delivery.orderUID }}</td>
                            <td>{{ delivery.orderDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="text-capitalize">
                                <p *ngIf="delivery.deliveryAddress">
                                    {{ delivery.deliveryAddress?.name }}
                                </p>
                                <p *ngIf="!delivery.deliveryAddress">{{ delivery.customerName || '-' }}</p>
                                <small *ngIf="delivery.deliveryAddress">
                                    {{ getFormattedAddress(delivery.deliveryAddress) }}
                                </small>
                            </td>
                            <td>
                                {{ (delivery.totalAmount + delivery.taxableAmount) | currency: 'INR':'symbol' }}
                            </td>
                            <td>{{ getOrderStatus(delivery.orderType) }}</td>
                            <td>
                                <span class="badge save-badge">{{ delivery.orderStatus }}</span><br>
                                <!--<small>{{ delivery.orderDate | date: 'dd/MM/yyyy' }}</small>-->
                            </td>
                            <td><span [ngClass]="{ 'badge save-badge': delivery.paymentStatus === 'Paid',
                            'badge danger-badge': delivery.paymentStatus === 'Not Paid' }">{{ delivery.paymentStatus }}
                            </span>
                            </td>
                            <td *ngIf="appCode !== 'MYKADAI'" (click)="$event.stopPropagation()">
                                <button type="button" class="accept btn btn" (click)="invoicePrint(delivery.orderId)">
                                    Print
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <div class="container-fluid" [style.display]="orderCloseShow ? 'block' : 'none'">
            <div class="row mt-3">
                <div class="col-md-12 table-responsive-md tableFixHead">
                    <table class="table  text-center">
                        <thead class="header sticky-top">
                        <tr>
                            <th>S.No</th>
                            <th>Order ID</th>
                            <th>Order Date</th>
                            <th>Customer Name</th>
                            <th>Total Bill Amount</th>
                            <th>Order Type</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let delivered of this.retailerDeliveredOrder | filter: searchText; let i = index;"
                            (click)="orderProductModalShow(delivered.orderId, 'Delivered', delivered.orderType);">
                            <td>{{ i + 1 }}</td>
                            <td>{{ delivered.orderUID }}</td>
                            <td>  {{ delivered.deliveredDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="text-capitalize">
                                <p *ngIf="delivered.deliveryAddress">
                                    {{ delivered.deliveryAddress?.name }}
                                </p>

                                <p *ngIf="!delivered.deliveryAddress">{{ delivered.customerName || '-' }}</p>
                                <small *ngIf="delivered?.deliveryAddress">{{ getFormattedAddress(delivered?.deliveryAddress) }}</small>
                            </td>
                            <td>{{ delivered.totalAmount + delivered.taxableAmount | currency:'INR':'symbol' }}</td>
                            <td>{{ getOrderStatus(delivered.orderType) }}</td>
                            <td><span class="badge danger-badge">{{ delivered.orderStatus }}</span>
                            </td>
                            <td>
                                <p *ngIf="delivered.paymentStatus == 'Paid'">
                                    <span class="badge save-badge">✔Paid</span>
                                </p>
                                <p *ngIf="delivered.paymentStatus == 'Not Paid'">
                                    <span class="badge danger-badge">✘Not Paid</span>
                                </p>
                            </td>
                        </tr>
                        <tr *ngIf="orderClosedCount == 0">
                            <td> No Order Found</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div [style.display]="isVisible ? 'block' : 'none'" style="background-color: rgba(229,229,229,0.51)" class="modal"
     tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="row modal-header">
                <div class="col-10">
                    <h3 class="text-center font-weight-bolder text-uppercase text-danger">Order Details</h3>
                    <h5 class="modal-title text-center text-gray-dark text-bold text-capitalize">{{ shopName }}</h5>
                    <h6 class="modal-title text-center" id="exampleModalLabel"><b>Order ID - {{ this.orderUID }}</b>
                    </h6>
                </div>
                <div class="col-2" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         class="bi bi-x-lg" viewBox="0 0 16 16" (click)="closeAlert();">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </div>
            </div>
            <div class="modal-body">
                <!--<div class="row mt-3 mb-3" *ngIf="deliveryDateShow">
                    <div class="col-md-12 flex-fill">
                        <div class="form-floating">
                            <input type="date" class="form-control" [min]="minDate" id="floatingPassword"
                                   placeholder="Password" [(ngModel)]="selectedDate" (change)="acceptShow($event)">
                            <label for="floatingPassword">Delivery Date</label>
                        </div>
                    </div>
                    <span *ngIf="!isDisabled" class="text-danger mt-3 col-12">Note: Please choose the delivery date before accept the order</span>
                </div>-->
                <div class="row mt-3 mb-1">
                    <div class="col-12">
                        <p class="text-bold">Customer Details</p>
                        <p class="text-primary">{{ modalProductShow?.customerName }}</p>
                        <p class="text-primary">{{ getFormattedAddress(modalProductShow?.deliveryAddress) }}</p>
                    </div>
                </div>
                <div class="container-fluid bg-primary p-2 sticky-top justify-content-center align-items-center">
                    <div class="col-md-12 text-center font-weight-bolder">
                        <h4 class="font-weight-bolder">MY CART</h4>
                    </div>
                </div>
                <div class="container-fluid y-scrollable">
                    <div class="col-md-12 table-responsive-md">
                        <table class="table table-borderless">
                            <thead>
                            <tr>
                                <th class="col-md-8">Item</th>
                                <th class="col-md-1 text-end">Quantity</th>
                                <th class="col-md-1 text-end">Price</th>
                                <th class="col-md-1 text-end">Tax</th>
                                <th class="col-md-1 text-end">Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let order of productList">
                                <td>{{ order.itemName }}</td>
                                <td class="text-end">{{ order.itemCount }}</td>
                                <td class="text-end">{{ order.itemSRP | currency:'INR':'symbol' }}</td>
                                <td class="text-end">{{ calculateTax(order) | currency:'INR':'symbol' }}</td>
                                <td class="text-end">{{ totalTaxAmount | currency:'INR':'symbol' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="container-fluid align-content-center">
                    <div class="col-md-12 text-center font-weight-bolder">
                        <!--<h6 class="font-weight-bold">Payment Details</h6>-->
                        <hr>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="col-md-12 table-responsive-md">
                        <table class="table table-borderless">
                            <thead>
                            <tr>
                                <th class="col-md-9 col-9">Total Amount</th>
                                <th class="col-md-1"></th>
                                <th class="col-md-1"></th>
                                <th class="col-md-1 col-3">{{ payableAmount |  currency:'INR':'symbol' }}</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer flex-column text-center">
                <!-- Payment Status Radio Buttons -->
                <div class="w-100" *ngIf="isPaymentStatusVisible() && modalProductShow?.paymentStatus != 'Paid'">
    <span class="error-text d-block mb-2">
      Note: If the customer has paid, select "Paid"; otherwise, select "Not Paid".
    </span>
                    <p class="mt-2 mb-2 fw-semibold">Update Payment Status</p>

                    <div class="d-flex justify-content-center gap-3 mb-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input"
                                   type="radio"
                                   name="paymentStatus"
                                   id="paidRadio"
                                   value="Paid"
                                   [(ngModel)]="paymentStatus">
                            <label class="form-check-label" for="paidRadio">Paid</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input"
                                   type="radio"
                                   name="paymentStatus"
                                   id="notPaidRadio"
                                   value="Not Paid"
                                   [(ngModel)]="paymentStatus">
                            <label class="form-check-label" for="notPaidRadio">Not Paid</label>
                        </div>
                    </div>
                </div>

                <!-- Centered Action Buttons -->
                <div class="d-flex flex-column align-items-center w-100">
                    <div *ngIf="!isDisabled && isAccepted" class="mb-2">
                        <button type="button" class="accept btn btn" (click)="orderStatus($event)" disabled>
                            Accepted
                        </button>
                    </div>
                    <div *ngIf="isDisabled && isAccepted" class="mb-2">
                        <button type="button" class="accept btn btn" (click)="orderStatus($event)">
                            Accepted
                        </button>
                    </div>
                    <div *ngIf="isReady" class="mb-2">
                        <button type="button" class="accept btn btn" (click)="orderStatus($event)">
                            Ready For Pickup
                        </button>
                    </div>
                    <div *ngIf="isDelivery" class="mb-2">
                        <button type="button" class="accept btn btn" (click)="orderStatus($event)">
                            Ready For Delivery
                        </button>
                    </div>
                    <div *ngIf="isClosed" class="mb-2">
                        <button type="button" class="accept btn btn" (click)="orderStatus($event)">
                            Delivered
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal" tabindex="-1" role="dialog" [style.display]="isVisibleCancel ? 'block' : 'none'">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <form [formGroup]="orderProcessing">
                <div class="modal-header">
                    <h5 class="modal-title text-center">Order Cancel Remarks ?</h5>
                </div>
                <div class="modal-body">
                    <select class="form-select" formControlName="reasonForCancel">
                        <option class="placeholder" value="" selected disabled>Select Reason For Cancellation</option>
                        <option value="Some products not available">Some products not available</option>
                        <option value="All products not available">All products not available</option>
                        <option value="Currently shop is closed">Currently shop is closed</option>
                        <option value="Temporarily not available - Call us later">Temporarily not available - Call us
                            later
                        </option>
                    </select>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="closeModal();">No
                    </button>
                    <button type="button" class="btn btn-primary" (click)="orderStatus($event)">Cancel Order</button>
                </div>
            </form>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>
